import React, { ReactElement } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { DataDueDiligence } from '@deecision/deeligenz-interfaces';
import { EntityListDataProvider, ListRendererMap, MultiModeList } from '../../entity/list';
import TableSkeleton from '../../layout/loading/tableskeleton';
import CustomPagination from '../../layout/pagination/pagination';
import { SearchParamsAccess, getSearchParamsContext, SearchParamsContextProvider } from '../../params';
import { DdsPublishTable } from './ddPublishListing';
import { DdPublishListingService } from '../../../services/ddpublish';

class DdListDataProvider extends EntityListDataProvider<DataDueDiligence> {
  constructor(searchParamsAccess: SearchParamsAccess, itemsPerPageMin?: number, itemsPerPageMax?: number) {
    super(searchParamsAccess, new DdPublishListingService(), itemsPerPageMin, itemsPerPageMax);
  }
}

export function DdMultiModeList(): ReactElement {
  const searchParamsAccess = getSearchParamsContext();
  const { t } = useTranslation();
  const listDataProvider = new DdListDataProvider(searchParamsAccess);

  const renderEmpty = () => (
    <>
      <div style={{ marginTop: '40px' }}>{t('dds.cardsAndTable.noDds')}</div>
    </>
  );

  const renderLoading = () => (<TableSkeleton nbColumns={8} />);

  const renderAsTable = (eltList: Array<DataDueDiligence>, totalCount: number) => (
    <>
      <DdsPublishTable list={eltList} paramsSort={listDataProvider.sortParamsManager} />
      <CustomPagination paramsPager={listDataProvider.paramsPager} totalItems={totalCount} />
    </>
  );

  const renderers: ListRendererMap<DataDueDiligence> = {
    'table': renderAsTable
    // 'cards': renderAsCards
  };

  return (
    <MultiModeList
      listDataProvider={listDataProvider}
      modes={['table']}
      defaultMode='table'
      renderers={renderers}
      renderEmpty={renderEmpty}
      renderLoading={renderLoading}
      // filtersComponent={DdFilters}
    />
  );
}

function DdPublish(): ReactElement {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = React.useState<URLSearchParams>(new URLSearchParams(window.location.search));

  return (
    <SearchParamsContextProvider value={new SearchParamsAccess(searchParams, setSearchParams, navigate)}>
      <DdMultiModeList />
    </SearchParamsContextProvider>
  );
}

export default DdPublish;
